export default {
  state: {
    modal: null,
    data: {},
  },
  mutations: {
    setModal(state, payload) {
      state.modal = payload.modal
      state.data = payload.data
    },
    clearModal(state) {
      state.modal = null
      state.data = {}
    },
  },
  actions: {
    showModal({commit}, payload) {
      commit('setModal', payload)
    },
    closeModal({commit}, event) {
      if (event === true || event.target.id === 'modal')
        commit('clearModal')
    },
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getModalData: state => {
      return state.data
    },
  }
}